/* eslint-disable */
export default {
  conferenceCall: 'Conferencia telefónica',
  onHold: 'En espera',
  ongoing: 'En curso',
  unknown: 'Desconocido',
  disconnected: 'Desconectado',
  loading: 'Cargando…',
  loadingTimeout: 'Tiempo de carga vencido.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
